import {Button} from "@material-ui/core";
import React from "react";
import {FormDataBookingItem} from "./FormDataBookingItem";
import {CheckBoxTerms} from "components/CheckBoxTerms";
import {Spinner} from 'reactstrap'
import {HtmlTooltip} from '../../components/HtmlTooltip'

interface Props {
  items: { name: string, required: boolean, placeholder: string }[]
  values: { [name: string]: string }

  handleOnClick(): void

  handleChange(name: string, value)

  t: any
  disabled: boolean
  datosPersonales: boolean
  carrito: boolean
  terminos: boolean
  expired?: boolean
  adding?: boolean
  loading
  loadedExists
  publicToken
  client
  checked
  handleChangeCheked
  existsTerms
  clickTerminos
  // additionalRequiredInformation
  setTelephoneFormat
}

export const FormDataBooking = (props: Props) => {
  const {
    adding,
    items,
    values,
    handleOnClick,
    handleChange,
    t,
    disabled,
    datosPersonales,
    carrito,
    terminos,
    expired,
    loading,
    loadedExists,
    publicToken,
    client,
    checked,
    handleChangeCheked,
    existsTerms,
    clickTerminos,
    // additionalRequiredInformation,
    setTelephoneFormat
  } = props

  const onChange = (event) => {
    handleChange(event.target.name, event.target.value)
  }

  return (
    <>
      <h4 className="tramoSeleccionado">{t("bookingDetails")}</h4>
      <div className="row centrado">
        <div className="col-sm-8">
          {
            items.map(item => (
              <FormDataBookingItem
                key={item.name}
                name={item.name}
                value={values[item.name]}
                placeholder={item.required? '* ' + item.placeholder : item.placeholder}
                required={item.required}
                onChange={onChange}
                t={t}
                // additionalRequiredInformation={additionalRequiredInformation}
                setTelephoneFormat={setTelephoneFormat}
              />
            ))
          }

          {!loading && loadedExists &&
          <CheckBoxTerms
            publicToken={publicToken}
            client={client}
            checked={checked}
            handleChangeCheked={handleChangeCheked}
            existsTerms={existsTerms}
            clickTerminos={clickTerminos}
          />
          }
        </div>
        <div className="col-sm-4 centrado" style={{/*padding: '50px'*/}}>
          {disabled &&
          <HtmlTooltip
            title={
              <React.Fragment>
                <ul>
                  {!carrito && <li>{t("noCart")}</li>}
                  {!datosPersonales && <li>{t("noData")}</li>}
                  {!terminos && <li>{t("noTerms")}</li>}
                  {expired && <li>{t("expiredItems")}</li>}
                </ul>
              </React.Fragment>
            }
            placement="top"
          >
            <span className="btn btn-huge btn-block btn-large">
                <button
                  style={{textDecorationColor: 'white'}} disabled={disabled}
                  type="submit"
                  className="btn btn-huge sobredimensionado btn-block btn-large btn-primary"
                  onClick={handleOnClick}>{t("book")}
                </button>
            </span>

          </HtmlTooltip>
          }
          {!disabled &&
          <span
            className="btn btn-huge btn-block btn-large">
            {!adding &&
            <Button
              disabled={disabled}
              type="submit"
              className="btn btn-huge sobredimensionado btn-block btn-large btn-primary"
              onClick={handleOnClick}>{t("book")}
            </Button>
            }
            {adding && 
              <Spinner/>
            }
          </span>
          }
        </div>
      </div>
    </>
  )
}
